// extracted by css-extract-rspack-plugin
export default {"size580":"580px","spaceSmall":"12px","dialogContainer":"data-export-success-genesis__dialogContainer___RzI_i","dialogBody":"data-export-success-genesis__dialogBody___XJ02C"};